import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import pick from "lodash/pick";

// Components
import DocumentsUploader from "../../utils/DocumentsUploader";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SortableDocumentList from "./SortableDocumentList";
import DragHandle from "../../utils/sortable/DragHandle";

// CSS
import "../../../css/forms/document-groups-edit.css";

// State
import { trainingDocsSuccess } from "../../../store/actions/trainingDocs";
import { userTokenUpdate } from "../../../store/actions/user";

// Utils
import { deleteTempImages } from "../../../utils/uploadHelpers";

class DocumentGroupEdit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			updateLoading: false,
			updateSuccess: "",
			promiseCollection: [],
			allowRetry: false
		};
	}

	handleUploads = () => {
		const { user } = this.props;

		// Trigger the upload start
		this.setState({ updateLoading: true, updateErrors: null }, () => {
			// Wait for all files to finish uploading
			Promise.all(this.state.promiseCollection).then(files => {
				// Files response is going to be a single-element array with the files within it.
				// Ex. files[0] = [file, file]
				files = files[0];

				// We might need to delete these later
				const uploadedUrls = [];
				if (!!files.length) {
					for (let i = 0; i < files.length; i++) {
						uploadedUrls[i] = pick(files[i].results, ["dirName", "filename"]);
					}
				}

				// Put request data together
				const data = {
					files: uploadedUrls,
					group_id: this.props.group.id
				};

				const token = user.token;
				const AUTH_HEADER = {
					Authorization: process.env.REACT_APP_SITE_KEY + ":Bearer " + token
				};
				return axios
					.post(process.env.REACT_APP_API_URL + "training-docs/new", data, {
						headers: AUTH_HEADER
					})
					.then(response => {
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}

						// ===================================
						//  ERROR
						// ===================================
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								promiseCollection: [],
								updateLoading: false,
								updateErrors: !isEmpty(response.data.errors)
									? response.data.errors
									: { general: response.data.message },
								allowRetry: true
							});

							deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
								console.log(err);
							});
						}
						// ===================================
						//  SUCCESS
						// ===================================
						else {
							// Reset state
							this.setState({
								updateLoading: false,
								updateSuccess: response.data.message,
								promiseCollection: [],
								allowRetry: false
							});

							// Update admin token
							this.props.userTokenUpdate("admin", response.data.token);

							// Update documents in store
							this.props.trainingDocsSuccess(response.data.groups);

							// Get new docs from store
							this.props.updateLocalStateFromProps();
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								promiseCollection: [],
								updateLoading: false,
								updateErrors: {
									general: err.response.data.error
										? err.response.data.error
										: err.response.data.message,
									allowRetry: true
								}
							});
						} else {
							this.setState({
								updateLoading: false,
								updateErrors: { general: err.message }
							});
						}

						deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
							console.log(err);
						});
					});
			});
		});
	};

	render() {
		const { group } = this.props;
		const { updateLoading, updateSuccess } = this.state;

		return (
			<div className="mb2">
				<div className="section-banner">
					{!!group.successful && <div className="success-wipe" />}
					<div className={`section-banner--title section-banner--edit`}>
						<DragHandle />
						<input
							className="blended-input"
							type="text"
							value={group.title}
							onChange={this.props.handleTitleChange}
							onKeyPress={e =>
								!!group.titleChanged && this.props.handleKeyPressTitle(e)
							}
						/>
						<button
							disabled={!!group.saving}
							className={
								"banner-button expand-btn" + (!group.minimize ? "" : " active")
							}
							onClick={() => this.props.changeGroupMinify(group)}
							title="Minimize"
						>
							<span className="icon-ellipsis-h" />
						</button>
						<button
							disabled={!!group.saving}
							className={
								`banner-button save-btn` + (!!group.titleChanged ? ` shown` : ``)
							}
							onClick={() => this.props.saveGroupTitle(group)}
							title="Save"
						>
							<span
								className={
									!!group.saving ? "loading icon-spinner" : "icon-checkmark"
								}
							/>
						</button>
						<button
							className="banner-button group-delete-btn"
							disabled={!!group.saving}
							onClick={() => this.props.deleteGroup(group)}
							title="Delete"
						>
							<span
								className={!!group.deleting ? "loading icon-spinner" : "icon-cross"}
							/>
						</button>
					</div>
				</div>

				<div className={`documents-container` + (!group.minimize ? "" : " hidden")}>
					<SortableDocumentList
						files={group.files}
						transitionDuration={200}
						lockAxis={"y"}
						lockToContainerEdges={true}
						lockOffset={"0%"}
						useDragHandle={true}
						helperClass="active-sort"
						{...this.props}
					/>

					{this.state.updateErrors && (
						<ErrorWrap animate={1} classes="row-error">
							{this.state.updateErrors}
						</ErrorWrap>
					)}
					{group.error && (
						<ErrorWrap animate={1} classes="row-error">
							{group.error}
						</ErrorWrap>
					)}

					<DocumentsUploader
						allowMultiple={true}
						loading={updateLoading}
						clear={!!updateSuccess}
						placeholder={"Drag files here"}
						uploadAssetType={"training-documents"}
						addPromise={promise => this.state.promiseCollection.push(promise)}
						handleFilesReadyToUpload={this.handleUploads}
						retryHandler={this.handleUploads}
						allowRetry={this.state.allowRetry}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ trainingDocsSuccess, userTokenUpdate }
)(DocumentGroupEdit);



// WEBPACK FOOTER //
// ./src/components/admin/training-documents/DocumentGroupEdit.js